var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPencilIcon = function SvgPencilIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16.5044,
    height: 16,
    transform: "translate(0.251953)",
    fill: "#DADADA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8528 3.00189C15.4391 3.57027 15.4487 4.48888 14.8744 5.06866L9.26342 10.7333C8.9839 11.0155 8.60026 11.1786 8.19677 11.1869L5.83971 11.2348L5.88948 8.93477C5.89776 8.55251 6.05866 8.18826 6.33834 7.91868L12.074 2.39012C12.6693 1.81631 13.6313 1.81765 14.2249 2.39311L14.8528 3.00189Z",
    fill: "#595959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9.12271 1.33398C9.50251 1.33398 9.81039 1.63246 9.81039 2.00065C9.81039 2.36884 9.50251 2.66732 9.12271 2.66732H4.37769C3.61809 2.66732 3.00232 3.26427 3.00232 4.00065V12.0007C3.00232 12.737 3.61809 13.334 4.37769 13.334H12.6299C13.3895 13.334 14.0053 12.737 14.0053 12.0007V8.66732C14.0053 8.29913 14.3132 8.00065 14.6929 8.00065C15.0727 8.00065 15.3806 8.29913 15.3806 8.66732V12.0007C15.3806 13.4734 14.1491 14.6673 12.6299 14.6673H4.37769C2.8585 14.6673 1.62695 13.4734 1.62695 12.0007V4.00065C1.62695 2.52789 2.8585 1.33398 4.37769 1.33398H9.12271Z",
    fill: "#595959"
  })));
};
export default SvgPencilIcon;